export class QueryValidationsFilter {
  validatorProviderId: number;
  dateFrom: Date;
  dateUntil: Date;
}
